
import Vue from "vue";
import msDataProvider from "../../services/msDataProvider";
import loginService from "../../services/loginService";
import uiService from "../../services/uiService";
import errorService from "../../services/errorService";
import {mdiArrowLeft} from "@mdi/js";
import {LOGIN_TYPE_KEY, OTP_METHOD, OtpType} from "@/constant/login";
import ErrorCard from "@/components/partials/ErrorCard.vue";
import ratingService from "@/services/ratingService";
import LocalStorage from "@/services/localStorage";

export default Vue.extend({
  components: {
    ErrorCard,
  },
  data() {
    return {
      OtpType,
      alertShown: false,
      errorService,
      mdiArrowLeft,
      error: "",
      sheet: false,
      binding: {},
      showOptionMethod: false,
      backendServerNameShown: false,
      backendServerNameSaving: false,
      backendServerName: "",
      otpTypeItems: [] as any,
      otpTypeLabels: {
        [OtpType.EmailOtp]: 'Email OTP',
        [OtpType.SMS]: 'SMS OTP',
        [OtpType.RADIUS]: 'Radius OTP',
        [OtpType.TOTP]: 'TOTP',
        [OtpType.SecurityKey]: 'Security Key'
      },
      required: (value) => !!value || this.$t("APP.REQUIRED"),
      prepareResponse: loginService.getPrepareLoginResponse() || {},
      showMenu: false,
      systemError: false,
      retried: false
    };
  },
  computed: {
    showNotiSystem() {
      const {showNotiSystem} = this.errorService.normalize(this.error);
      return showNotiSystem;
    },
    optionNotification() {
      return {
        attrs: {
          class: "noti-bottom",
        },
        content: {
          title: () => {
            return this.$t("PREPARE.CONNECTIVITY_LOST");
          },
          html: () => {
            return this.errorService.normalize(this.error).err;
          },
        },
        button: {
          content: {
            text: this.$t("PREPARE.RETRY"),
            icon: "icon-right",
          },
          on: {
            click: () => {
              this.prepare();
            },
          },
        },
      };
    },
    optionOtp() {
      return OTP_METHOD.includes(this.prepareResponse.type);
    }
  },
  methods: {
    async logout() {
      if (
          await uiService.executeCommand(
              "confirmShow",
              {
                message: this.$t("LAYOUT.DO_YOU_REALLY_WANT_TO_LOGOUT_THIS_APP"),
                title: this.$t("LAYOUT.LOGOUT"),
                cancel: this.$t("LAYOUT.CANCEL"),
                ok: this.$t("LAYOUT.LOGOUT"),
                iconOk: 'icon-logout-white24'
              },
              true
          )
      ) {
        uiService.executeCommand("try", {
          async func() {
            await msDataProvider.executeCommand("authenLogout", {});
            await this.prepare();
            this.$router.push("/login/username_password").catch((e) => e);
          },
          self: this,
        });
      }
    },
    tryMfa(mfa) {
      this.sheet = false;
      this.prepare({
        expected_mfas: [mfa],
      });
    },
    async prepare(params: any = {}) {
      this.error = "";
      this.systemError = false;
      try {
        const backendServerName = await msDataProvider.executeCommand(
            "backendServerNameGetCurrentValue"
        );
        if (!backendServerName) {
          this.$router.push("first_time_login").catch((e) => e);
          return;
        }
        this.backendServerName = backendServerName;
      } catch (e) {
        console.log(e)
      }
      try {
        const response = await msDataProvider.executeCommand(
            "authenPrepareLogin",
            params
        );
        if (response.new_backend_server_name) {
          location.reload();
          return;
        }
        loginService.setPrepareLoginResponse(response);
        this.prepareResponse = response;
        this.filterOtpType();
        if (response.error_info.error_code) {
          this.error = response.error_info.message;
          return;
        }
        const loginType = LocalStorage.getItem(LOGIN_TYPE_KEY);
        if(!loginType || typeof loginType !== 'object') {
          await this.$router.push({path: '/login/select_server_name', query: {firstTime: true}});
          return;
        }
        if (!response.type) {
          this.$router.push("/prepare").catch((e) => e);
          return;
        }
        switch (response.type) {
          case "UsernamePassword":
            if (Array.isArray(response?.available_login_methods)) {
              const foundMethod = response.available_login_methods.find(
                  loginMethod => loginMethod.name === loginType[this.backendServerName]
              );
              if (foundMethod?.type === 'open_id_connect') {
                this.$router.push('/login/open_id_connect').catch((e) => e);
                return;
              }
            }
            this.$router.push("/login/username_password").catch((e) => e);
            break;
          case "Totp":
            this.$router.push("/login/totp").catch((e) => e);
            break;
          case "SmsOtp":
            this.$router.push("/login/sms_otp").catch((e) => e);
            break;
          case "RadiusOtp":
            this.$router.push("/login/radius_otp").catch((e) => e);
            break;
          case "EmailOtp":
            this.$router.push("/login/email_otp").catch((e) => e);
            break;
          case "SecurityKey":
            this.$router.push("/login/security_key").catch((e) => e);
            break;
        }
      } catch (e) {
        if (!this.retried) {
          this.retried = true;
          await this.prepare()
        } else {
          this.error = e;
          this.systemError = true;
        }
      }
    },

    async changeOtpType(type: OtpType) {
      this.expected_mfas = [type];
      await this.prepare({expected_mfas: [type]});
    },
    async changeBackendServerName() {
      if (!this.backendServerName || this.backendServerNameSaving) {
        return;
      }
      this.backendServerNameSaving = true;
      try {
        await msDataProvider.executeCommand(
            "backendServerNamePing",
            this.backendServerName
        );
      } catch (e) {
        if (
            !(await uiService.executeCommand(
                "confirmShow",
                {
                  message: `${this.$t("APP.CANNOT_CONNECT_TO")} ${
                      this.backendServerName
                  }. ${this.$t("APP.DO_YOU_STILL_WANT_TO_CONTINUE")}?`,
                  title: this.$t("APP.WARNING"),
                  cancel: this.$t("APP.CANCEL"),
                  ok: this.$t("APP.YES"),
                  detail: `${e}`,
                },
                true
            ))
        ) {
          this.backendServerNameSaving = false;
          return;
        }
      }

      await msDataProvider.executeCommand(
          "backendServerNameSetCurrentValue",
          this.backendServerName
      );
      this.backendServerName = "";
      this.backendServerNameShown = false;
      this.backendServerNameSaving = false;
      location.reload();
    },
    openChangeBackendServerNameModal() {
      uiService.executeCommand('backendServerNameShow', {});
    },
    filterOtpType() {
      if (Array.isArray(this.prepareResponse.available_mfas)) {
        this.otpTypeItems = [];
        this.prepareResponse.available_mfas.map(mfa => {
          if (OTP_METHOD.includes(mfa)) {
            this.otpTypeItems.push(mfa);
          }
        })
      }
    },
  },
  async created() {
    const params: any = {};
    if (this.$route.query.type) {
      params.expected_mfas = [this.$route.query.type];
    }
    if (this.$route.query.resend) {
      params.force_new_session = true;
    }
    ratingService.sessionUpdate(true);
    await msDataProvider.bindDataMany(
        [
          "updateAvailableVersionsInfo",
          "updateApplied",
          "backendServerNameCurrentValue",
          "backendServerNameDefaultValue",
          "setting",
        ],
        this.binding,
        this,
        null,
        this
    );
    await this.prepare(params);
    this.filterOtpType();
  },
});
